
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import {
  defaultArgTypes,
  defaultArgs,
  generateGroundNavProps,
} from './ground-nav-args.js';
import template from './demo/ground-nav-demo.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {/*
     Inline stories disabled so media queries will behave as expected within
     embedded examples.
     */}
    <Meta title="Components/Ground Nav" parameters={{
      docs: {
        inlineStories: false
      },
      layout: 'fullscreen'
    }} mdxType="Meta" />
    <h1>{`Ground Nav`}</h1>
    <p>{`The yin to `}<a parentName="p" {...{
        "href": "/docs/components-sky-nav--dark"
      }}>{`Sky Nav`}</a>{`'s yang, the Ground Nav sits at the bottom of all our pages. It includes a call to action, contact information, an expanded navigation menu for lost users and any legal copy.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Cloud Four" height="815px" args={defaultArgs} argTypes={defaultArgTypes} parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {args => template(generateGroundNavProps(args))}
  </Story>
    </Canvas>
    <p>{`If you only define a single feature block, it will be centered.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="One Feature" height="800px" args={{
        ...defaultArgs,
        feature_count: 1
      }} argTypes={defaultArgTypes} parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {args => template(generateGroundNavProps(args))}
  </Story>
    </Canvas>
    <p>{`If you don't define any feature blocks, the layout will collapse appropriately.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="No Features" height="475px" args={{
        ...defaultArgs,
        feature_count: 0
      }} argTypes={defaultArgTypes} parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {args => template(generateGroundNavProps(args))}
  </Story>
    </Canvas>
    <p>{`Note that the Ground Nav uses a pseudo-element to fake the page background color
bleeding down behind the feature blocks on large screens. If the previous block
is using `}<inlineCode parentName="p">{`background-secondary`}</inlineCode>{`, you can set `}<inlineCode parentName="p">{`c-ground-nav--alternate`}</inlineCode>{` to swap
the background colors of the Ground Nav to match.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Alternate" height="815px" args={{
        ...defaultArgs,
        alternate: true
      }} argTypes={defaultArgTypes} parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {args => template(generateGroundNavProps(args))}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`feature_count`}</inlineCode>{`: The number of feature blocks to display. Defaults to 2.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`organization`}</inlineCode>{`: Object containing Cloud Four details for contact information and copyright. Structure and property names are based on the `}<a parentName="li" {...{
          "href": "https://schema.org/Organization"
        }}>{`the Organization schema`}</a>{`.`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`address`}</inlineCode>
            <ul parentName="li">
              <li parentName="ul"><inlineCode parentName="li">{`street_address`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`address_locality`}</inlineCode>{` (city)`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`address_region`}</inlineCode>{` (state)`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`postal_code`}</inlineCode>{` (zip)`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`address_country`}</inlineCode></li>
            </ul>
          </li>
          <li parentName="ul"><inlineCode parentName="li">{`email`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`telephone`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`url`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`founding_date`}</inlineCode>{`: Used for start date of default legal content.`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`menu`}</inlineCode>{`: An object containing navigation menu `}<inlineCode parentName="li">{`items`}</inlineCode>{` to iterate over in the same structure as that expected by `}<a parentName="li" {...{
          "href": "https://timber.github.io/docs/guides/menus/"
        }}>{`Timber menus`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`topics`}</inlineCode>{`: The same structure as `}<inlineCode parentName="li">{`menu`}</inlineCode>{` but for content topics.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`social`}</inlineCode>{`: The same structure as `}<inlineCode parentName="li">{`menu`}</inlineCode>{` but for social links. Each item must also contain an `}<inlineCode parentName="li">{`icon`}</inlineCode>{` property corresponding to a key from `}<a parentName="li" {...{
          "href": "/docs/design-icons--page"
        }}>{`our icon library`}</a>{`.`}</li>
    </ul>
    <h2>{`Template Blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`legal`}</inlineCode>{`: Optional HTML content to display in the legal section. If not provided, a copyright statement will be displayed by default.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`feature_one`}</inlineCode>{`: Optional HTML content to display in the first feature slot.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`feature_two`}</inlineCode>{`: Optional HTML content to display in the second feature slot.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const cloudFour = (args => template(generateGroundNavProps(args)));
cloudFour.storyName = 'Cloud Four';
cloudFour.argTypes = defaultArgTypes;
cloudFour.args = defaultArgs;
cloudFour.parameters = { storySource: { source: 'args => template(generateGroundNavProps(args))' }, ...{
  layout: 'fullscreen'
} };

export const oneFeature = (args => template(generateGroundNavProps(args)));
oneFeature.storyName = 'One Feature';
oneFeature.argTypes = defaultArgTypes;
oneFeature.args = {
  ...defaultArgs,
  feature_count: 1
};
oneFeature.parameters = { storySource: { source: 'args => template(generateGroundNavProps(args))' }, ...{
  layout: 'fullscreen'
} };

export const noFeatures = (args => template(generateGroundNavProps(args)));
noFeatures.storyName = 'No Features';
noFeatures.argTypes = defaultArgTypes;
noFeatures.args = {
  ...defaultArgs,
  feature_count: 0
};
noFeatures.parameters = { storySource: { source: 'args => template(generateGroundNavProps(args))' }, ...{
  layout: 'fullscreen'
} };

export const alternate = (args => template(generateGroundNavProps(args)));
alternate.storyName = 'Alternate';
alternate.argTypes = defaultArgTypes;
alternate.args = {
  ...defaultArgs,
  alternate: true
};
alternate.parameters = { storySource: { source: 'args => template(generateGroundNavProps(args))' }, ...{
  layout: 'fullscreen'
} };

const componentMeta = { title: 'Components/Ground Nav', parameters: {
  docs: {
    inlineStories: false
  },
  layout: 'fullscreen'
}, includeStories: ["cloudFour","oneFeature","noFeatures","alternate"],  };

const mdxStoryNameToKey = {"Cloud Four":"cloudFour","One Feature":"oneFeature","No Features":"noFeatures","Alternate":"alternate"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;